import React, { Component } from "react";
import { useEffect } from "react";
import * as d3 from "d3";
import moment from "moment";

class stackBar extends Component {
  constructor(props) {
    super();
    this.state = {
      chartData: props.chartData,
    };
  }

  bar = () => {
    const parentThis = this;
    var pwidth = document.getElementById("lower-left").clientWidth;
    var pheight = document.getElementById("lower-left").clientHeight;
    var margin = { top: 10, right: 30, bottom: 90, left: 40 },
      width = pwidth - margin.left - margin.right - 70,
      height = pheight - margin.top - margin.bottom - 18;
    // append the svg object to the body of the page
    var svg = d3
      .select("#my_stackbar")
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .style("margin-left", "30px")
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    let data = this.state.chartData;
    // List of subgroups = header of the csv files = soil condition here
    var subgroups = Object.keys(data[0]).slice(1, 4);
    var groups = d3
      .map(data, function (d) {
        return d.Date;
      })
      .keys();
    var x = d3.scaleBand().domain(groups).range([0, width]).padding([0.2]);
    svg
      .append("g")
      .attr("transform", "translate(0," + height + ")")
      .call(d3.axisBottom(x))
      .selectAll("text")
      .attr("transform", "translate(-10,0)rotate(-45)")
      .style("text-anchor", "end");

    // Add Y axis
    const yDataArr = data.map(function (object) {
      return Number(object.Stoppage) + Number(object.Running); // creating array of values
    });

    let maxValue = d3.max(yDataArr); // defining max value
    if (maxValue <= 0) {
      maxValue = 5;
    }

    var y = d3.scaleLinear().domain([0, maxValue]).range([height, 0]);
    svg.append("g").call(
      d3
        .axisLeft(y)
        .ticks(10)
        .tickFormat(function (d) {
          return (d / 60).toFixed(0) + "h";
        })
    );

    var color = d3
      .scaleOrdinal()
      .domain(subgroups)
      .range(["#273c75", "#13abd4"]);

    var stackedData = d3.stack().keys(subgroups)(data);
    var tooltip = d3
      .select("#my_stackbar")
      .append("div")
      .style("opacity", 0)
      .attr("class", "tooltip")
      .style("background-color", "white")
      .style("border", "solid")
      .style("border-color", "#fc5c65")

      .style("border-width", "2px")
      .style("border-radius", "5px")
      .style("padding", "10px")
      .style("width", "110px")
      .style("height", "50px")
      .style("position", "absolute");
    var mouseover = function (event, d) {
      if (parentThis.props.actionOnClick) {
        parentThis.props.actionOnClick(d.data.Vehicles);
      }

      var subgroupName = d3.select(this.parentNode).datum().key;
      var subgroupValue = d.data[subgroupName];
      var running = moment
        .utc()
        .startOf("day")
        .add({
          minutes: d.data.Running,
        })
        .format("H:mm");

      var stoppage = moment
        .utc()
        .startOf("day")
        .add({
          minutes: d.data.Stoppage,
        })
        .format("H:mm");

      tooltip
        .html("Running: " + running + "<br>" + "Stoppage: " + stoppage)
        .style("opacity", 1)
        .style("font-size", "11px")
        .style("color", "black")
        .style("font-width", "500");
    };
    var mousemove = function (event) {
      tooltip
        .style("margin-left", d3.pointer(event)[0] - 10 + "px")
        .style("margin-top", d3.pointer(event)[1] - 347 + "px");
    };
    var mouseleave = function (event, d) {
      tooltip.style("opacity", 0);
    };

    svg
      .append("text")
      .attr("class", "y label")
      .attr("text-anchor", "end")
      .attr("y", -40)
      .attr("x", -50)
      .attr("dy", ".73em")
      .attr("transform", "rotate(-90)")
      .text(this.props.label)
      .style("font-size", "12px");

    svg
      .append("g")
      .selectAll("g")
      .data(stackedData)
      .enter()
      .append("g")
      .attr("fill", function (d) {
        return color(d.key);
      })
      .selectAll("rect")
      .data(function (d) {
        return d;
      })
      .enter()
      .append("rect")
      .attr("x", function (d) {
        return x(d.data.Date);
      })
      .attr("y", function (d) {
        return y(d[1]);
      })
      .attr("height", function (d) {
        return y(d[0]) - y(d[1]);
      })
      .attr("width", x.bandwidth())
      .attr("stroke", "grey")
      .on("mouseover", mouseover)
      .on("mousemove", mousemove)
      .on("mouseleave", mouseleave)
      .on("mouseout", function () {
        tooltip.style("opacity", 0);
        if (parentThis.props.actionOnClick) {
          parentThis.props.actionOnClick("");
        }
      });
  };

  componentDidMount() {
    this.bar();
  }
  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(this.props.chartData) !==
      JSON.stringify(prevProps.chartData)
    ) {
      this.setState(
        {
          chartData: this.props.chartData || [],
        },
        function () {
          if (this.state.chartData.length > 0) {
            d3.select("#my_stackbar").html("");
            this.bar();
          }
        }
      );
    }
  }

  render() {
    return (
      <div style={{ height: "320px", marginTop: "30px" }}>
        <div id="my_stackbar"></div>
      </div>
    );
  }
}

export default stackBar;
